module.exports = __webpack_public_path__ + "static/media/prototype_banner_img.e4787f25.png";